// Masraf politika uyarısının saf mantığı. Kategori limitleri talebi ASLA
// bloklamaz; aşımda şirketin ödemeyi taahhüt ettiği tutar (payableAmount)
// kırpılır ve bu tutar her ekranda gösterilir.

const TRY = 'TRY';

export const formatPolicyAmount = (value, currency) => {
  const amount = Number(value || 0);
  return currency && currency !== TRY
    ? `${amount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`
    : new Intl.NumberFormat('tr-TR', {
      style: 'currency', currency: TRY, minimumFractionDigits: 2, maximumFractionDigits: 2,
    }).format(amount);
};

// Kayıtlı talep (liste satırı / detay). `showsPayable`, kırpmanın gerçekten
// uygulanmış olmasına bağlıdır: kural öncesi satırlarda bayrak var ama ödenecek
// tutar talebin tamamına eşittir — orada "şu kadarı ödenecek" demek, sistemin
// hiç vermediği bir kararı iddia etmek olurdu.
export function describeSavedExpensePolicy(row) {
  if (!row || !row.isPolicyViolation) return null;

  const totalAmount = Number(row.totalAmount || 0);
  const hasPayable = row.payableAmount != null;
  const payableAmount = hasPayable ? Number(row.payableAmount) : totalAmount;
  const exceededAmount = totalAmount - payableAmount;

  return {
    codes: row.violationCodes || [],
    totalAmount,
    payableAmount,
    exceededAmount,
    showsPayable: hasPayable && exceededAmount > 0,
    limitAmount: row.perTransactionLimitAtEntry ?? null,
    monthlyLimitAmount: row.monthlyLimitAtEntry ?? null,
    currency: row.currency || TRY,
  };
}

// İstemci tarafı yedek: önizleme ucu ulaşılamadığında bile çalışan uyarısız
// kalmasın. Kategori listesi işlem başı limiti zaten taşır; aylık limit için
// çalışanın ay-içi toplamı gerektiğinden yerel hesap yapılamaz.
export function localPerTransactionPolicy({ perTransactionLimit, totalAmount, currency }) {
  if (currency && currency !== TRY) return null;
  if (perTransactionLimit == null) return null;

  const limit = Number(perTransactionLimit);
  const total = Number(totalAmount || 0);
  if (!(total > limit)) return null;

  return {
    codes: ['perTransactionLimit'],
    totalAmount: total,
    payableAmount: limit,
    exceededAmount: total - limit,
    perTransactionLimit: limit,
    monthlyEmployeeLimit: null,
    monthlyConsumed: 0,
    monthlyRemaining: null,
    currency: currency || TRY,
    isFallback: true,
  };
}

// Giriş ekranı uyarısı: sunucu önizlemesi tek otoritedir, yoksa yerel hesaba düşülür.
export function describeEntryPolicy({ preview, fallback }) {
  if (preview) {
    if (!preview.isPolicyViolation) return null;

    const totalAmount = Number(preview.totalAmount || 0);
    const payableAmount = Number(preview.payableAmount || 0);

    return {
      codes: preview.violationCodes || [],
      totalAmount,
      payableAmount,
      exceededAmount: preview.exceededAmount != null
        ? Number(preview.exceededAmount)
        : totalAmount - payableAmount,
      perTransactionLimit: preview.perTransactionLimit ?? null,
      monthlyEmployeeLimit: preview.monthlyEmployeeLimit ?? null,
      monthlyConsumed: Number(preview.monthlyConsumed || 0),
      monthlyRemaining: preview.monthlyRemaining ?? null,
      currency: preview.currency || TRY,
      isFallback: false,
    };
  }

  return fallback ? localPerTransactionPolicy(fallback) : null;
}

// Ödemeyi yapan kişi, kırpılmış bir talebi "ödendi" işaretlemeden önce ödenecek
// tutarı görmeli. İhlalsiz talepler tek tıkla işaretlenmeye devam eder.
export function requiresPayableConfirmation(row, nextPaymentStatus) {
  if (nextPaymentStatus !== 'paid') return false;
  const policy = describeSavedExpensePolicy(row);
  return Boolean(policy?.showsPayable);
}
